import * as React from 'react';
import { ArticleHeading5, InlineText2, InlineText3 } from '@cian/ui-kit';

import * as styles from './styles.css';
import { ETransportType } from '../../types/transportType';
import { Underground } from '../Underground';

interface INewbuildingCardProps {
  imageUrl: string;
  builder: string;
  name: string;
  fullUrl: string;
  price: string;
  status: string;
  undergroundColor: string;
  undergroundName: string;
  transportType?: ETransportType | null;
  undergroundTimeTo: string;
  regionId: number | null;
  onClick(): void;
}

export function NewbuildingCard({
  imageUrl,
  builder,
  name,
  fullUrl,
  price,
  status,
  regionId,
  undergroundColor,
  undergroundName,
  transportType,
  undergroundTimeTo,
  onClick,
}: INewbuildingCardProps) {
  const displayName = `ЖК «${name}»`;

  return (
    <a
      href={fullUrl}
      target="_blank"
      rel="noreferrer"
      className={styles['container']}
      title={`${displayName} от ${builder}`}
      onClick={onClick}
    >
      <div className={styles['hovered-block']}>
        <div className={styles['img']} style={{ backgroundImage: `url(${imageUrl})` }} />
      </div>
      <div className={styles['builder']}>
        <InlineText3 color="text-secondary-default" whiteSpace="nowrap">
          {builder}
        </InlineText3>
      </div>
      <div className={styles['content']}>
        <ArticleHeading5 as="h5" whiteSpace="nowrap">
          {displayName}
        </ArticleHeading5>
        <InlineText2>{price}</InlineText2>
        <InlineText2>{status}</InlineText2>
      </div>
      {undergroundColor && undergroundName && (
        <Underground
          lineColor={undergroundColor}
          name={undergroundName}
          regionId={regionId}
          transportType={transportType}
          timeTo={undergroundTimeTo}
        />
      )}
    </a>
  );
}
